<template>
  <div style="height: 100%">
    <div class="nothing" v-if="tableData && tableData.length === 0">
      <img src="../../../assets/img/not_found_data.png" alt="">
    </div>
    <el-table
        v-if="tableData && tableData.length !== 0"
        :data="tableData"
        height="90%"
        :header-cell-style='{background: "#6cc9eb"}'
        style="width: 100%;">
      <el-table-column
          prop="enterpriseName"
          label="企业名称/个人姓名">
        <template slot-scope="scope">
          <div style="font-size: 18rem" v-if="!scope.row.isShowBtn">{{ scope.row.enterpriseName }}</div>
          <el-input v-else size="mini" v-model="ROW_DATA.enterpriseName"
                    style="width: 90%; font-size: 18rem"></el-input>
        </template>
      </el-table-column>
      <el-table-column
          prop="phoneNumber"
          label="联系电话"
          width="180"
      >
        <template slot-scope="scope">
          <div style="font-size: 18rem">{{ scope.row.phoneNumber }}</div>
        </template>
      </el-table-column>
      <el-table-column
          prop="startTime"
          label="入住时间"
          width="240"
      >
        <template slot-scope="scope">
          <div style="font-size: 18rem" v-if="!scope.row.isShowBtn">{{ scope.row.startTime }}</div>
          <el-date-picker
              style="font-size: 18rem"
              size="mini"
              v-else
              value-format="yyyy-MM-dd HH:mm:ss"
              v-model="ROW_DATA.startTime"
              type="datetime"
              placeholder="选择日期时间">
          </el-date-picker>
          <!--          <el-input v-else size="mini" v-model="ROW_DATA.startTime" style="width: 90%"></el-input>-->
        </template>
      </el-table-column>
      <el-table-column
          prop="endTime"
          label="退租时间"
          width="240"
      >
        <template slot-scope="scope">
          <div style="font-size: 18rem">{{ scope.row.endTime }}</div>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="200"
      >
        <template slot-scope="scope">
          <el-button style="margin-right: 20rem; font-size: 18rem" v-if="!scope.row.isShowBtn"
                     @click="handleClick('edit', scope.row)"
                     type="text" size="small">修改
          </el-button>
          <span v-else style="margin-right: 20rem;">
            <el-button style="font-size: 18rem" :loading="loading" @click="handleClick('save', scope.row)" type="text"
                       size="small">保存</el-button>
            <el-button style="font-size: 18rem" @click="handleClick('cancel', scope.row)" type="text"
                       size="small">取消</el-button>
          </span>
          <el-popconfirm
              title="确定删除吗？"
              confirm-button-text='是'
              cancel-button-text='否'
              @confirm="handleClick('delete', scope.row)"
          >
            <el-button slot="reference" type="text" size="small" style="color: #E8684A; font-size: 18rem">删除
            </el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        v-if="tableData && tableData.length !== 0"
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
    </el-pagination>
    <DialogEntering
        ref="DialogEnteringRef"
        :type="typeDialogEnter"
        :title="titleDialogEnter"
    />
    <DialogDelete
        ref="DialogDeleteRef"
        @getInit="getInit"
    />
  </div>
</template>

<script>
import {
  GET_V3_Cost_Enterprise_List_Page,
  POST_V3_Cost_Enterprise_SaveOrUpdate,
  POST_V3_Cost_Enterprise_Delete
} from '@/api/billing.js'
import DialogEntering from './dialogEntering'
import DialogDelete from './dialogDelete'

export default {
  name: "tableTenant",
  components: {DialogEntering, DialogDelete},
  data() {
    return {
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      },
      ROW_DATA: {},
      loading: false,
      typeDialogEnter: '',
      titleDialogEnter: ''
    }
  },
  props: ['tabidx', 'searchValue', 'isRequest'],
  methods: {
    handleDialog(type, type2, title) {
      switch (type) {
        case 'entering':
          this.typeDialogEnter = type2
          this.titleDialogEnter = title
          this.$refs.DialogEnteringRef.dialogVisible = true;
          break;
        default:
          return;
      }
    },

    getInit() {
      this.$emit('update:isRequest', true)
      GET_V3_Cost_Enterprise_List_Page(
          this.pagination.current,
          this.pagination.size,
          {
            enterpriseName: this.searchValue
          }
      ).then((res) => {
        this.tableData = res.data.data.records.map(item => {
          return {
            ...item,
            isShowBtn: false
          }
        })
        this.pagination.current = res.data.data.current
        this.pagination.size = res.data.data.size
        this.pagination.total = res.data.data.total
        // this.$emit('update:isRequest', false)
      })

      setTimeout((res) => {
        this.$emit('update:isRequest', false)
      }, 500)
      // console.log('租户管理列表', this.tableData)
    },

    handleList(list, item, flag) {
      // console.log('list, item, flag ==  ', list, item, flag)
      this.tableData = list.map(val => {
        return {
          ...val,
          isShowBtn: item.id === val.id ? flag : false
        }
      })
    },

    async handleClick(type, row) {
      // console.log(row);
      switch (type) {
        case 'edit':
          this.ROW_DATA = {
            enterpriseName: row.enterpriseName,
            startTime: row.startTime
          }
          this.handleList(this.tableData, row, true)
          // console.log('修改');
          break
        case 'save':
          this.loading = true
          const data = await POST_V3_Cost_Enterprise_SaveOrUpdate({
            ...row,
            ...this.ROW_DATA
          });
          // console.log('保存', data);
          if (data.data.code === 200) {
            this.$message.success("保存成功！");
            await this.getInit()
          } else {
            this.$message.error("保存失败！");
          }
          this.loading = false
          this.handleList(this.tableData, row, false);
          this.ROW_DATA = {}
          break
        case 'cancel':
          this.handleList(this.tableData, row, false);
          this.ROW_DATA = {}
          // console.log('取消');
          break
        case 'delete':
          this.$refs.DialogDeleteRef.dialogVisible = true
          console.log(row)
          this.$refs.DialogDeleteRef.tenement = row
          break
        default:
          return
      }
    },

    handleSizeChange(val) {
      this.pagination.size = val
      this.getInit()
    },

    handleCurrentChange(val) {
      this.pagination.current = val
      this.getInit()
    },
  },
  watch: {
    tabidx(val) {
      if (val === 3) {
        this.getInit()
      } else {
        return
      }
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-table__body-wrapper.is-scrolling-none {
  height: 671rem !important; /* 设置滚动区域的高度为100% */
}

.pagination {
  padding-top: 30rem;
  text-align: right;
}

.nothing {
  width: 100%;
  height: 100%;
  position: relative;

  & > img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>